var map = {
	"./000.png": "cd3c",
	"./BRA.png": "9d97",
	"./CHL.png": "0be7",
	"./COL.png": "65b9",
	"./ECU.png": "b75b",
	"./MEX.png": "7f85",
	"./PAN.png": "7b6d",
	"./PER.png": "da39",
	"./USA.png": "cf8f",
	"./VEN.png": "831c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88d4";